import * as t from 'io-ts';

export const prefAndCityByZipcode = t.type({
  pref: t.string,
  city: t.string,
  city_cd: t.string,
  city_rome: t.string,
  code: t.string,
  message: t.string,
});

export type PrefAndCityByZipcode = t.TypeOf<typeof prefAndCityByZipcode>;

export const provAndCityItem = t.type({
  province: t.string,
  province_local: t.string,
  address: t.string,
  address_local: t.string,
  parent_code: t.string,
  area_code: t.string,
  city_code: t.string,
  short_name: t.string,
});

export type ProvAndCityItem = t.TypeOf<typeof provAndCityItem>;

export const provAndCityByZipcodeResponse = t.type({
  list: t.array(provAndCityItem),
  code: t.string,
  message: t.string,
});

export type ProvAndCityByZipcodeResponse = t.TypeOf<typeof provAndCityByZipcodeResponse>;

export const simulatorDetailTruckOptionPriceClearance = t.type({
  price: t.number,
  tax: t.number,
  service_charge_clearance: t.number,
  service_charge_handring: t.number,
  peak_season_surcharge: t.number,
});

export type SimulatorDetailTruckOptionPriceClearance = t.TypeOf<
  typeof simulatorDetailTruckOptionPriceClearance
>;

export const simulatorDetailTruckOptionPrice = t.intersection([
  t.type({
    price: t.number,
    total_price: t.number,
    on_sea_price: t.number,
    import_tax: t.number,
    target_tax_price: t.number,
    non_target_tax_price: t.number,
  }),
  t.partial({
    target_price: t.number,
    price2: t.number,
    tax_price: t.number,
    shipping_tax: t.number,
    clearance: simulatorDetailTruckOptionPriceClearance,
  }),
]);

export const simulatorDetailTruckOptionLeadtime = t.type({
  delivery_leadtime: t.string,
});

export const simulatorDetailTruckOption = t.type({
  truck_type: t.string,
  price: simulatorDetailTruckOptionPrice,
  lead_time: simulatorDetailTruckOptionLeadtime,
});

export const simulatorDetailBaggage = t.intersection([
  t.type({
    total_kg_num: t.number,
    total_m3kg: t.number,
    total_m3_num: t.number,
    total_m3: t.number,
  }),
  t.partial({
    target_kg: t.number,
    base: t.string,
  }),
]);

export type SimulatorDetailBaggage = t.TypeOf<typeof simulatorDetailBaggage>;

export const simulatorDetailPickupInfo = t.type({
  detail: t.array(t.any), // TODO
  total_price: t.number,
});

export const simulatorDetailPickupPortChargeInfoDetail = t.intersection([
  t.type({
    area: t.string,
    name: t.string,
    unit: t.string,
    code: t.string,
    price: t.number,
    price2: t.number,
    pair: t.string,
    exchange_base_rate: t.number,
    exchange_base_date: t.string,
  }),
  t.partial({
    minimum_flg: t.number,
    grade_rate: t.number,
    unit_price: t.number,
    unit_price2: t.number,
    base_kg: t.number,
    minimum: t.number,
  }),
]);

export type SimulatorDetailPickupPortChargeInfoDetail = t.TypeOf<
  typeof simulatorDetailPickupPortChargeInfoDetail
>;

export const simulatorDetailPickupPortChargeInfo = t.type({
  detail: t.array(simulatorDetailPickupPortChargeInfoDetail),
  total_price: t.number,
});

export const simulatorDetailPickupWarehouseChargeInfoDetail = t.type({
  warehouse_code: t.string,
  pod_code: t.string,
  name: t.string,
  unit_type: t.string,
  price: t.number,
  pair: t.string,
  price2: t.number,
  currency: t.string,
});

export const simulatorDetailPickupWarehouseChargeInfo = t.type({
  detail: t.array(simulatorDetailPickupWarehouseChargeInfoDetail),
  total_price: t.number,
});

export const simulatorDetailPickup = t.type({
  pickup_info: simulatorDetailPickupInfo,
  port_charge_info: simulatorDetailPickupPortChargeInfo,
  warehouse_charge_info: simulatorDetailPickupWarehouseChargeInfo,
  total_price: t.number,
});

export const simulatorDetail = t.intersection([
  t.type({
    list: t.array(simulatorDetailTruckOption),
    base: t.string,
    baggage: simulatorDetailBaggage,
    target_kg: t.number,
    pickup: simulatorDetailPickup,
    warehouse: t.string,
    pol: t.string,
    pod: t.string,
    service: t.string,
    service_id: t.string,
  }),
  t.partial({
    on_sea_measure: t.number, // unknown meaning
  }),
]);

export type SimulatorDetail = t.TypeOf<typeof simulatorDetail>;

export const simMemberResponse = t.type({
  data: t.array(simulatorDetail),
  code: t.string,
  message: t.string,
});

export type SimMemberResponse = t.TypeOf<typeof simMemberResponse>;

export const authIssueResponse = t.type({
  status: t.string,
  message: t.string,
  data: t.type({
    access_token: t.string,
    expires_in: t.string,
    message: t.string,
    refresh_token: t.string,
    status: t.string,
    system_code: t.string,
  }),
  timestamp: t.string,
  alignment: t.string,
});

export type AuthIssueResponse = t.TypeOf<typeof authIssueResponse>;

export const createKikanDaichoResponse = t.type({
  status: t.string,
  message: t.string,
  data: t.type({
    job_code: t.string,
  }),
  timestamp: t.string,
  alignment: t.string,
});

export type CreateKikanDaichoResponse = t.TypeOf<typeof createKikanDaichoResponse>;

export const getDenpyoShiharaiKigenbiResponse = t.type({
  status: t.string,
  message: t.string,
  data: t.type({
    close_day: t.string,
    pay_day: t.string,
  }),
  timestamp: t.string,
  alignment: t.string,
});

export type GetDenpyoShiharaiKigenbiResponse = t.TypeOf<typeof getDenpyoShiharaiKigenbiResponse>;

export const createShiharaiDenpyoResponse = t.type({
  status: t.string,
  message: t.string,
  data: t.type({
    costs_no: t.string,
  }),
  timestamp: t.string,
  alignment: t.string,
});

export type CreateShiharaiDenpyoResponse = t.TypeOf<typeof createShiharaiDenpyoResponse>;
